import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Figure, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import useToastContext from "../hooks/useToastContext";
import moment from "moment";
import { BASE_URL } from "../services/path";
import { getUserEventByIdAPI } from "../hooks/ApisContainer/Event";
import LottiLoader from "../components/shared/Loader/LottiLoader";
import NoDataFound from "../components/shared/Loader/NoDataAnimation";

const SingleEvent = () => {
  var singleEventSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  const { id } = useParams();
  const notification = useToastContext();
  const navigate = useNavigate();

  const [eventDetail, setEventDetail] = useState({});
  const [loader, setLoader] = useState([]);

  const fetchedGetEventByID = () => {
    const requestPayload = { id: id };
    getUserEventByIdAPI(
      requestPayload,
      notification,
      (loading, error, response) => {
        setLoader(loading);
        if (!error) {
          setEventDetail(response);
        }
      }
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchedGetEventByID();
  }, []);

  return (
    <div className="inner-wrapper pb-0">
      <div
        className={`page-title ${
          Object.keys(eventDetail).length > 0 && "mb-md-5 mb-3"
        }`}
      >
        <div class="common-heading text-center mb-sm-3 mb-2">
          <h2>Events </h2>
        </div>
        <Breadcrumb>
          <Breadcrumb.Item
            onClick={() => navigate("/")}
            className="text-decoration-none "
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => navigate("/events")}
            className="text-orange"
          >
            Events
          </Breadcrumb.Item>
          {eventDetail?.name && (
            <Breadcrumb.Item active className="text-orange">
              {eventDetail.name}
            </Breadcrumb.Item>
          )}
        </Breadcrumb>
      </div>
      {loader ? (
        <Container className="d-flex justify-content-center align-items-center default-back">
          <span>
            <LottiLoader height={120} width={120} loader={true} />
          </span>
        </Container>
      ) : (
        Object.keys(eventDetail || {}).length > 0 && (
          <section className="mb-md-5 mb-sm-3 mb-2">
            <Container>
              <Row>
                <Col md={12} className="mb-4 d-flex">
                  <Card className="sponser-cards speaker-box-layout2 position-relative w-100 rounded overflow-hidden">
                    <div className="event-date-time position-absolute z-index1 top-0 bg-black border-white m-2 text-white px-3">
                      <span className="event-date">
                        <i className="bi bi-calendar3 text-white"></i>{" "}
                        {moment(eventDetail.date).format("DD MMM YYYY")}
                      </span>
                      <span className="event-time">
                        <i className="bi bi-clock text-white"></i>{" "}
                        {eventDetail.time}
                      </span>
                    </div>
                    <Figure>
                      <Slider
                        {...singleEventSlider}
                        className="home-slider mt-0"
                      >
                        {eventDetail?.eventImages?.map((item) => {
                          return (
                            <div className="event-slider">
                              <img
                                src={`${BASE_URL}/uploads/${item}`}
                                alt=""
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://t4.ftcdn.net/jpg/07/95/29/45/240_F_795294584_LZ4NllndEBSy8vbi37sYngiLIaPdUvtQ.jpg";
                                }}
                              />
                            </div>
                          );
                        })}
                      </Slider>
                    </Figure>
                    <Card.Body className="text-start d-flex flex-column justify-content-between">
                      <div className="">
                        <Card.Title
                          className="multi-truncate"
                          style={{ fontSize: "18px", fontWeight: "bold" }}
                        >
                          {eventDetail.name}
                        </Card.Title>

                        <Card.Text
                          style={{ color: "gray", fontSize: "14px" }}
                          className=" font-bold text-black"
                        >
                          {eventDetail.description}
                        </Card.Text>
                        <p className="event-location">
                          <i className="bi bi-geo-alt"></i>{" "}
                          {eventDetail.address}...
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        )
      )}
      {!loader && Object.keys(eventDetail || {})?.length == 0 && (
        <NoDataFound height={200} width={200} firstMessage="No Event found." />
      )}
    </div>
  );
};

export default SingleEvent;
